/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import DailyClosingDetail from './DailyClosingDetail'
import DailyClosingHead from './DailyClosingHead'
import DailyClosingReservation from './DailyClosingReservation'

/**
 * The InlineResponse20023 model module.
 * @module model/InlineResponse20023
 * @version 1.0.0
 */
export default class InlineResponse20023 {
  /**
   * Constructs a new <code>InlineResponse20023</code>.
   * @alias module:model/InlineResponse20023
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>InlineResponse20023</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse20023} obj Optional instance to populate.
   * @return {module:model/InlineResponse20023} The populated <code>InlineResponse20023</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse20023()

      if (data.hasOwnProperty('daily_closing_head')) {
        obj['daily_closing_head'] = DailyClosingHead.constructFromObject(data['daily_closing_head'])
      }
      if (data.hasOwnProperty('daily_closing_details')) {
        obj['daily_closing_details'] = ApiClient.convertToType(data['daily_closing_details'], [DailyClosingDetail])
      }
      if (data.hasOwnProperty('daily_closing_reservations')) {
        obj['daily_closing_reservations'] = ApiClient.convertToType(data['daily_closing_reservations'], [DailyClosingReservation])
      }
    }
    return obj
  }

  /**
   * @member {module:model/DailyClosingHead} daily_closing_head
   */
  daily_closing_head = undefined
  /**
   * @member {Array.<module:model/DailyClosingDetail>} daily_closing_details
   */
  daily_closing_details = undefined
  /**
   * @member {Array.<module:model/DailyClosingReservation>} daily_closing_reservations
   */
  daily_closing_reservations = undefined
}
